/*
 Plugin Name: Campaign Tracking
 Plugin URI: http://www.interconnectit.com
 Description: Will log GET parameters to cookie for a time and append them to any outgoing link that matches pattern
 Version: 1.0.0
 Author: interconnect/it, JRW
 Author URI: http://www.interconnectit.com

 Usage: jQuery( 'a' ).campaignTracking( {
 get: [ 'get_string1', 'get_string2', 'get_string3', 'etc..' ],
 host: 'outbound-host-name-the-get-params-will-be-added-to.com',
 time: 3600, // Time in seconds that the cookie will hold the values for.
 overwrite: false // Boolean, replace the any parameters in the outbound link with those from the cookie/get
 });
 */

;(function( $ ) {
	'use strict';

	/**
	 * Main control object
	 */
	var parseQueryString =
			function( search ) {
				var objURL = {},
					str    = search || window.location.search;

				str.replace(
					new RegExp( "([^?=&]+)(=([^&]*))?", "g" ),
					function( $0, $1, $2, $3 ) {
						objURL[ $1 ] = $3;
					}
				);

				return objURL;
			};
	// Create the jQuery extensions
	$.fn.extend(
		{
			campaingTracking: function( q ) {
				var defaults      = {
						get: [],
						host: '',
						time: 86400,
						overwrite: false
					},
					settings      = $.extend( {}, defaults, q ), // Merge the settings with the defaults
					searchVars    = parseQueryString(), // Get all the params from the query string
					trackingCodes = {}, // Store the tracking data in here.
					hostRegExp    = new RegExp( '^.*' + settings.host + '.*', 'gi' );

				// Something is wrong, run away!
				if ( typeof Cookies !== 'function' ) {
					console.log( 'js.cookie not loaded.' );
					return;
				}

				// Check for get parameters that match the settings.
				for ( var i in settings.get ) {
					// Something weird is going on!!!
					if ( !settings.get.hasOwnProperty( i ) ) {
						continue;
					}

					// If there's something in the search string matching our requirements store it in the cookie.
					if ( typeof searchVars[ settings.get[ i ] ] !== 'undefined' ) {
						Cookies.set(
							settings.get[ i ],
							searchVars[ settings.get[ i ] ],
							// js.Cookies takes days but we want fractions of days.
							{ expires: ( settings.time > 0 ? settings.time / 86400 : 0 ) }
						);
					}

					// If they've just been added to the cookie or been there a while this will get the most appropriate
					// tracking codes to add to the outgoing URL.
					if ( Cookies.get( settings.get[ i ] ) ) {
						trackingCodes[ settings.get[ i ] ] = Cookies.get( settings.get[ i ] );
					}
				}

				return this.each( function( i, node ) {
					var $node  = $( node ),
						search = $node.get( 0 ).search, // The search string
						hash   = $node.get( 0 ).hash,
						href   = $node.prop( 'href' ).replace( search, '' ).replace( hash, '' ); // The link without the search string or hash.

					// This isn't an anchor so lets just run away.
					if ( !$node.is( 'a' ) ) {
						return node;
					}

					// The link matches our requirements and we've got tracking attributes.
					if ( href.match( hostRegExp ) && Object.keys( trackingCodes ).length ) {
						$node.on( 'click', function( e ) {
							var searchVars = trackingCodes;

							// Stop the default click and replace it with a window.location change with our params added.
							e.preventDefault();

							// Is there a search string already in the URL?
							if ( search.length ) {
								// Do the vars in the href have priority?
								if ( settings.overwrite ) {
									searchVars = $.extend( parseQueryString( search ), searchVars );
								}
								else {
									searchVars = $.extend( searchVars, parseQueryString( search ) );
								}
							}

							// Step over each query var pair and append them to the output
							if ( Object.keys( searchVars ).length ) {
								search = $.map(
									searchVars,
									function( v, o ) {
										return ( v && o ) ? o + '=' + v : null;
									} ).join( '&' );
							}

							// Make sure we've got a "?" at the head of the search string
							if ( search.length && !search.match( /^\?/ ) ) {
								search = '?' + search;
							}

							// Finally we'll head to the URL
							window.location = href + search + hash;
							//console.debug( href + search + hash );
						} );
					}

					return node;
				} );
			}
		} );

}( jQuery ));
